<script>
import { CampPage } from '@/api'
import PageFormBase from '@/crudBases/form/PageFormBase'
import fields from '@/components/fields/'
import { get } from 'lodash'

export default {
  extends: PageFormBase,
  data() {
    return {
      livePreview: true,
      redirectRoute: { name: 'CampPages List' },
      livePreviewIframeSrc: '/preview/camp/',
      charsetsOptions: [
        {
          label: 'Russian',
          value: 'ru'
        },
        {
          label: 'Thai',
          value: 'th'
        },
        {
          label: 'Japanese',
          value: 'jp'
        },
        {
          label: 'Chinese',
          value: 'zh'
        },
        {
          label: 'Arabic',
          value: 'ar'
        }
      ]
    }
  },
  methods: {
    getGeneralFields() {
      return [
        new fields.Switch({
          label: 'Use redirect',
          modelPath: [this, 'form', 'use_redirect']
        }),
        new fields.Input({
          label: 'Redirect path',
          modelPath: [this, 'form', 'redirect_path']
        }),
        new fields.Switch({
          label: 'Is booking available',
          modelPath: [this, 'form', 'is_booking_available']
        }),
        new fields.Input({
          label: 'Title',
          modelPath: [this, 'form', 'title'],
          multilingual: true
        }),
        new fields.Input({
          label: 'Submenu label',
          modelPath: [this, 'form', 'submenu_label'],
          multilingual: true
        }),
        new fields.Select({
          label: 'Special characters set',
          modelPath: [this, 'form', 'charset'],
          options: this.charsetsOptions
        }),
        new fields.ForeignKey({
          label: 'Parent',
          modelPath: [this, 'form', 'parent'],
          labelField: `title_${this.currentLanguage}`,
          valueField: 'id',
          clearable: true,
          required: false,
          disabled:
            get(this, ['form', 'is_home']) || get(this, ['form', 'has_child']),
          service: CampPage,
          serviceParams: this.getServiceParams()
        }),
        new fields.Date({
          label: 'Created',
          type: 'datetime',
          modelPath: [this, 'form', 'created']
        })
      ]
    },
    getServiceParams() {
      let params = { page_size: 'max' }
      if (this.$router.history.current.params.id) {
        params['id__not'] = this.$router.history.current.params.id
      }
      return params
    }
  },
  computed: {
    service() {
      return CampPage
    },
    currentLanguage() {
      return this.$store.state.selectedLanguage
    }
  }
}
</script>
